import { Vector, str } from 'scale-ts';

const docs = Vector(str);

export { docs };
//# sourceMappingURL=docs.mjs.map
